import { type Component, defineAsyncComponent } from "vue";

import type { DraftBulkAction } from "./types";

interface ComponentProps {
  action: unknown;
}

const components: Record<DraftBulkAction["type"], Component<ComponentProps>> = {
  apply_tags: defineAsyncComponent(
    () => import("./actions/ApplyTagsAction.vue")
  ),
  ban_subscribers: defineAsyncComponent(
    () => import("./actions/BanSubscribersAction.vue")
  ),
  delete_comments: defineAsyncComponent(
    () => import("./actions/DeleteCommentsAction.vue")
  ),
  delete_emails: defineAsyncComponent(
    () => import("./actions/DeleteEmailsAction.vue")
  ),
  delete_subscribers: defineAsyncComponent(
    () => import("./actions/DeleteSubscribersAction.vue")
  ),
  delete_surveys: defineAsyncComponent(
    () => import("./actions/DeleteSurveysAction.vue")
  ),
  delete_surveys_responses: defineAsyncComponent(
    () => import("./actions/DeleteSurveysResponsesAction.vue")
  ),
  delete_tags: defineAsyncComponent(
    () => import("./actions/DeleteTagsAction.vue")
  ),
  gift_subscribers: defineAsyncComponent(
    () => import("./actions/GiftSubscribersAction.vue")
  ),
  reactivate_subscribers: defineAsyncComponent(
    () => import("./actions/ReactivateSubscribersAction.vue")
  ),
  replay_external_events: defineAsyncComponent(
    () => import("./actions/ReplayExternalEventsAction.vue")
  ),
  resubscribe_subscribers: defineAsyncComponent(
    () => import("./actions/ResubscribeSubscribersAction.vue")
  ),
  send_email: defineAsyncComponent(
    () => import("./actions/SendEmailAction.vue")
  ),
  send_reminder: defineAsyncComponent(
    () => import("./actions/SendReminderAction.vue")
  ),
  unflag_subscribers: defineAsyncComponent(
    () => import("./actions/UnflagSubscribersAction.vue")
  ),
  ungift_subscribers: defineAsyncComponent(
    () => import("./actions/UngiftSubscribersAction.vue")
  ),
  unsubscribe_subscribers: defineAsyncComponent(
    () => import("./actions/UnsubscribeSubscribersAction.vue")
  ),
  update_emails_type: defineAsyncComponent(
    () => import("./actions/UpdateEmailsTypeAction.vue")
  ),
  update_surveys_status: defineAsyncComponent(
    () => import("./actions/UpdateSurveysStatusAction.vue")
  ),
};

export default components;
